import Funds from 'components/global/Funds';

const VCFunds = () => <Funds />;

export default VCFunds;
